// Handles submission of the cart form
document.addEventListener('DOMContentLoaded', function () {
  if (window.subscribe) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      const cartRes = await fetch('/cart.js');

      if (!cartRes.ok) {
        publish(PUB_SUB_EVENTS.notification, {
          source,
          error: 'Error: Network response was not ok',
        });
      }

      const cart = await cartRes.json();

      if (!cart) {
        publish(PUB_SUB_EVENTS.notification, {
          source,
          error: 'Error: Failed to retrieve cart',
        });
      }

      const cartDrawer = document.getElementById('moia-cart-drawer-anchor');
      const fontColorClass = cartDrawer.getAttribute('data-font-color-class');
      const fontColorClass50 = cartDrawer.getAttribute('data-font-color-class-50');
      const fontColor50 = cartDrawer.getAttribute('data-font-color-50');

      await sectionReplace({
        sectionQuery: '/?sections=moia-navigation-header',
        sectionName: 'moia-navigation-header',
        mainAnchorId: 'moia-cart-drawer-anchor',
        targetAnchorId: 'moia-cart-drawer-anchor-target',
        targetedClassUpdates: [
          {
            classDefault: 'moia-color-blue',
            classReplace: fontColorClass,
          },
          {
            classDefault: 'moia-color-blue-50',
            classReplace: fontColorClass50,
          },
        ],
        targetedStyleUpdates: [
          {
            selector: '#moia-cart-drawer-header',
            styleName: 'borderBottom',
            styleValue: `solid 3px var(${fontColor50})`,
          },
        ],
      });
    });
  }

  // Only runs on moia-cart-drawer-form element
  if (!customElements.get('moia-cart-drawer-form')) {
    customElements.define(
      'moia-cart-drawer-form',
      class MoiaCartDrawerForm extends HTMLElement {
        constructor() {
          super();

          // Line-items form (footer has a separate checkout form)
          this.form = this.querySelector('.moia-cart-drawer-items-form');
          if (this.form) {
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          }

          this.addEventListener('click', (event) => {
            // Remove item
            const removeBtn = event.target.closest('.moia-cart-item-remove');
            if (removeBtn && removeBtn.dataset.itemKey) {
              this.closeItem(removeBtn.dataset.itemKey);
            }

            // Drawer close
            const closeBtn = event.target.closest('button');
            if (
              closeBtn &&
              (closeBtn.id === 'moia-cart-drawer-header-empty-close-button' ||
                closeBtn.id === 'moia-cart-drawer-header-empty-shop-button' ||
                closeBtn.id === 'moia-cart-drawer-header-close-button')
            ) {
              this.closeDrawer();
            }
          });
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
        }

        closeItem(itemKey) {
          updateCartItem(
            {
              id: itemKey,
              quantity: 0,
            },
            'moia-cart-drawer'
          );
        }

        closeDrawer() {
          // Hide the drawer and curtain
          const drawer = this.closest('.moia-cart-drawer-container');
          const curtain = document.querySelector('.moia-cart-drawer-curtain');
          if (drawer) drawer.classList.remove('active');
          if (curtain) curtain.classList.remove('active');
        }
      }
    );
  }
});
